import { PrCreateItem } from "../service/sap.service";

// Mapping from WaysOfBuying integer values to SAP document type codes
const WaysOfBuyingToSapDocType: { [key: number]: string } = {
  1: "NB",
  2: "FO",
  3: "Z004"
};


export const extractPrNumberFromResponse = (response: string | any): string | null => {
  try {
    const jsonResponse = typeof response === 'string' ? JSON.parse(response) : response;
    
    if (jsonResponse?.d?.PrNumber) {
      return jsonResponse.d.PrNumber;
    }
    
    return null;
  } catch (error) {
    console.error("Error parsing response:", error);
    return null;
  }
};

export const extractSapErrorMessage = (error: any): string => {
  return "Failed to create purchase requisition. Please try again.";
};

export const createPrCreateRequestBody = (order: any[]): any => {
  // Map materials to PrCreate items
  const prCreateItems: PrCreateItem[] = order.map(({ material, quantity }, index) => {
    const itemNo = String((index + 1) * 10).padStart(5, '0'); // 00010, 00020, 00030, etc.
    return mapMaterialToPrCreateItem(material, quantity, itemNo);
  });

  const primaryWayOfBuying = order[0]?.material?.waysOfBuying?.[0] || 1;
  const docType = WaysOfBuyingToSapDocType[primaryWayOfBuying] || "NB";

  return {
    results: {
      PrNumber: "",
      DocType: "NB",
      TaskNumber: "",
      Test_Run: "",
      HeaderToItem: {
        results: prCreateItems
      }
    }
  };
};

export const mapMaterialToPrCreateItem = (material: any, quantity: number, itemNo: string): PrCreateItem => {
  const sortedPriceRanges = [...material.priceRanges].sort((a, b) => {
    return a.quantity < b.quantity ? 1 : -1;
  });
  const applicablePriceRange = sortedPriceRanges.find((r) => quantity >= r.quantity);
  const price = applicablePriceRange?.price || 0;

  const primaryWayOfBuying = material.waysOfBuying?.[0] || 1;
  const docType = WaysOfBuyingToSapDocType[primaryWayOfBuying] || "NB";

  // Calculate dates
  const today = new Date();
  const reqDate = today.toISOString().slice(0, 10).replace(/-/g, ''); // YYYYMMDD format
  const delivDate = new Date(today.getTime() + 60 * 24 * 60 * 60 * 1000); // 2 months ahead
  const delivDateFormatted = delivDate.toISOString().slice(0, 10).replace(/-/g, ''); // YYYYMMDD format

  return {
    PrItemNo: itemNo,
    PurGroup: "LVG",
    Material: material.materialNumber,
    ShortText: material.shortDescription,
    Plant: "0650",
    Quantity: quantity.toString(),
    Unit: material.unitOfMeasure,
    DocType: "NB",
    ItemCat: "0",
    AccAssignmentCat: "K",
    DelivDate: delivDateFormatted,
    ReqDate: reqDate,
    PriceUnit: "1",
    Currency: material.currencyCode,
    GlAcc: "5014030",
    CostCenter: "0065041001",
    ValPrice: price.toString(),
    Vendor: material.supplierCode,
    ExtReqNo: material.pslIdWithPrefix + '_' + material.materialId.toString()
  };
};
